import { InfraConstants } from 'infra/infraConstants';

type ModuleListReloaderProps = {
    updateTimeout?: number;
    loadList: AnyFunction;
    initialLoadList?: AnyFunction;
    selectIsLoaded?: AnyFunction;
    fetchImmediate?: boolean;
};
export class ModuleListReloader {
    private updateTimeoutId?: number;
    private consumersCount = 0;
    private readonly updateTimeout: number;
    private readonly initialLoadList: AnyFunction;
    private readonly loadList: AnyFunction;
    private readonly selectIsLoaded: (...args: any[]) => boolean;
    private skipNextTick: boolean;

    constructor({
        updateTimeout = InfraConstants.LIST_UPDATE_INTERVAL,
        loadList,
        initialLoadList = loadList,
        selectIsLoaded = () => true,
        fetchImmediate = true,
    }: ModuleListReloaderProps) {
        if (!loadList) {
            throw new Error(
                'loadlist method should be provided to ModuleListReloader instance',
            );
        }

        this.updateTimeout = updateTimeout;
        this.initialLoadList = initialLoadList;
        this.loadList = loadList;
        this.selectIsLoaded = selectIsLoaded;
        this.skipNextTick = !fetchImmediate;
    }

    load = (args) => async (dispatch, getState) => {
        const isLoaded = this.selectIsLoaded(getState());
        try {
            if (isLoaded) {
                await dispatch(this.loadList(...args));
            } else {
                await dispatch(this.initialLoadList(...args));
            }
        } catch (error) {
            console.warn(error);
        }
    };

    addConsumer = (...args) => async (dispatch) => {
        this.consumersCount++;

        const func = () => dispatch(this.load(args));
        if (this.consumersCount > 1) {
            await func();
            return;
        }

        await this.tick(func);
    };

    async tick(func) {
        if (this.skipNextTick) {
            this.skipNextTick = false;
        } else {
            await func();
        }

        window.clearTimeout(this.updateTimeoutId);

        if (this.consumersCount < 1) {
            return;
        }

        this.updateTimeoutId = window.setTimeout(
            () => this.tick(func),
            this.updateTimeout,
        );
    }

    removeConsumer = () => async () => {
        this.consumersCount--;
        if (this.consumersCount < 1) {
            window.clearTimeout(this.updateTimeoutId);
        }
    };
}
